module.exports = __webpack_public_path__ + "static/media/ball_1_6.c8854ecd.mp3";